// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-primary: #6a11cb;
  --color-secondary: #f857a6;
  --color-success: #00b09b;
  --color-danger: #ff5858;
  --color-warning: #ffd166;
  --color-info: #4facfe;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-primary);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  line-height: 1.6;
}

/* Main Container */
.MaterialStock-container {
  max-width: 1400px;
  margin: 0 auto;
  /* padding: 1.5rem; */
  min-height: 100vh;
}

/* Header Section */

.MaterialStock-header {
  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */
  background: linear-gradient(135deg, #4c6a37 100%, #cae4db 0%);
  padding: 11px 20px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.MaterialStock-header::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 60%
  );
  animation: pulse 15s infinite linear;
}

@keyframes pulse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.MaterialStock-header-content {
  position: relative;
  z-index: 2;
}

.MaterialStock-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.MaterialStock-subtitle {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.9;
  text-align: center;
}

.MaterialStock-header-icon {
  width: 1.75rem;
  height: 1.75rem;
}

.MaterialStock-header h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.MaterialStock-header-subtitle {
  margin: 0;
  font-size: 0.95rem;
  opacity: 0.9;
  font-weight: 400;
}

/* Controls Section */
.MaterialStock-controls-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.MaterialStock-search-container {
  position: relative;
  flex: 1 1;
  max-width: 350px;
}

.MaterialStock-search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  height: 1rem;
  color: var(--color-text-tertiary);
}

.MaterialStock-search-input {
  width: 100%;
  padding: 0.625rem 0.75rem 0.625rem 2.5rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  background: var(--color-bg-primary);
  transition: var(--transition-fast);
  box-sizing: border-box;
}

.MaterialStock-search-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.MaterialStock-control-buttons {
  display: flex;
  gap: 0.75rem;
}

/* Buttons */
.MaterialStock-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border: none;
  border-radius: var(--border-radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast);
  text-decoration: none;
  white-space: nowrap;
  font-size: 0.875rem;
}

.MaterialStock-btn-icon {
  width: 1rem;
  height: 1rem;
}

.MaterialStock-btn-xs {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
}

.MaterialStock-btn-sm {
  /* padding: 0.5rem 1rem; */
  padding: 4px 16px;
  font-size: 0.875rem;
}

.MaterialStock-btn-primary {
  /* background: var(--primary-gradient); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #4c6a37;
  color: white;
  box-shadow: var(--shadow-sm);
}

.MaterialStock-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.MaterialStock-btn-secondary {
  /* background: var(--secondary-gradient); */
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #4c6a37;
  color: white;
  box-shadow: var(--shadow-sm);
}

.MaterialStock-btn-secondary:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.MaterialStock-btn-outline {
  background: transparent;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
}

.MaterialStock-btn-outline:hover {
  background: var(--color-bg-tertiary);
  border-color: var(--color-text-secondary);
}

.MaterialStock-btn-danger {
  background: linear-gradient(135deg, #ff5858 0%, #ff4757 100%);
  color: white;
}

.MaterialStock-btn-danger:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.MaterialStock-btn-icon {
  padding: 0.375rem;
  width: auto;
  height: auto;
}

.MaterialStock-btn-edit {
  background: var(--success-gradient);
  color: white;
}

.MaterialStock-btn-delete {
  background: var(--secondary-gradient);
  color: white;
}

/* Modal */
.MaterialStock-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.MaterialStock-modal-container {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
}

.MaterialStock-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid var(--color-border);
}

.MaterialStock-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text-primary);
}

.MaterialStock-modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.375rem;
  border-radius: var(--border-radius-sm);
  color: var(--color-text-secondary);
  transition: var(--transition-fast);
}

.MaterialStock-modal-close-btn:hover {
  background: var(--color-bg-tertiary);
  color: var(--color-text-primary);
}

/* Form */
.MaterialStock-transfer-form {
  padding: 1.5rem;
}

.MaterialStock-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.MaterialStock-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.MaterialStock-form-group label {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.MaterialStock-form-input,
.MaterialStock-form-select {
  padding: 0.625rem 0.75rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  background: var(--color-bg-primary);
  transition: var(--transition-fast);
}

.MaterialStock-form-input:focus,
.MaterialStock-form-select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

/* Materials Section */
.MaterialStock-materials-section {
  margin-bottom: 1.5rem;
}

.MaterialStock-materials-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  margin-top: 10px;
}

.MaterialStock-materials-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialStock-materials-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.MaterialStock-material-item {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 1rem;
  background: var(--color-bg-tertiary);
  border-radius: var(--border-radius-sm);
  border: 1px solid var(--color-border);
}

.MaterialStock-material-inputs {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 5px;
  flex: 1 1;
}

.MaterialStock-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}

/* Transfers Section */
.MaterialStock-transfers-section {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.MaterialStock-section-header {
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  padding: 1.5rem;
  text-align: center;
  /* background: var(--card-gradient); */
  /* border-bottom: 1px solid var(--color-border); */
}

.MaterialStock-section-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-text-primary);
}

.MaterialStock-transfer-count {
  background: var(--primary-gradient);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: var(--border-radius-xl);
  font-size: 0.75rem;
  font-weight: 600;
}

/* Table */
.MaterialStock-table-container {
  overflow-x: auto;
}

.MaterialStock-transfers-table {
  width: 100%;
  border-collapse: collapse;

  background: var(--color-bg-primary);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  box-shadow: var(--shadow-md);
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
}

.MaterialStock-transfers-table th {
  background: var(--color-bg-tertiary);
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid var(--color-border);
}

.MaterialStock-transfers-table td {
  padding: 1rem;
  border-bottom: 1px solid var(--color-border);
  vertical-align: top;
  font-size: 0.875rem;
}

.MaterialStock-transfers-table tr:hover {
  background: var(--color-bg-secondary);
}

.MaterialStock-date-text {
  font-weight: 600;
  /* color: var(--color-primary); */
  color: #0d5787;
}

.MaterialStock-site-cell {
  display: flex;
  align-items: center;
  /* flex-direction: column; */
  font-size: 15px;
}

.MaterialStock-site-name {
  font-weight: 600;
  /* color: var(--color-text-primary); */
  /* color: #fff; */
}

.Material-SiteName-Badge {
  display: inline-flex; /* shrink to fit content */
  align-items: center;
  justify-content: center;
  width: fit-content; /* ensures background fits content only */
  background: #4c6a37;
  /* background: linear-gradient(135deg, #20948b 0%, #66a5ad 100%); */
  color: #fff;
  border-radius: 1rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap; /* prevents wrapping if site name is long */
}

.MaterialStock-LocationIcon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.MaterialStock-note-text {
  color: var(--color-text-secondary);
  font-style: italic;
}

.MaterialStock-material-name {
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialStock-qty,
.MaterialStock-cost,
.MaterialStock-total {
  font-weight: 500;
  color: var(--color-text-primary);
}

.MaterialStock-total {
  font-weight: 700;
  color: var(--color-success);
}

.MaterialStock-action-buttons {
  display: flex;
  gap: 0.375rem;
}

/* Grand Total Section */
.MaterialStock-grand-total-section {
  padding: 1.5rem;
  background: var(--card-gradient);
  border-top: 1px solid var(--color-border);
}

.MaterialStock-grand-total {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}

.MaterialStock-grand-total-label {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialStock-grand-total-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-success);
  background: var(--color-bg-primary);
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius-sm);
  box-shadow: var(--shadow-sm);
}

/* Empty State */
.MaterialStock-empty-state {
  text-align: center;
  padding: 3rem 2rem;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-sm);
}

.MaterialStock-empty-icon {
  width: 3rem;
  height: 3rem;
  color: var(--color-text-tertiary);
  margin-bottom: 1rem;
}

.MaterialStock-empty-state h3 {
  margin: 0 0 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-text-primary);
}

.MaterialStock-empty-state p {
  margin: 0;
  color: var(--color-text-secondary);
}

/* Print Styles */
@media print {
  .MaterialStock-no-print {
    display: none !important;
  }

  .MaterialStock-container {
    padding: 0;
    max-width: none;
  }

  .MaterialStock-header {
    background: none !important;
    color: black !important;
    box-shadow: none !important;
    border: 2px solid black;
  }

  .MaterialStock-controls-section {
    display: none !important;
  }

  .MaterialStock-transfers-table {
    font-size: 12px;
    border: 1px solid black;
  }

  .MaterialStock-transfers-table th,
  .MaterialStock-transfers-table td {
    padding: 8px;
    border: 1px solid black;
  }

  .MaterialStock-transfers-table th {
    background: #f0f0f0 !important;
  }

  .MaterialStock-grand-total-section {
    background: none !important;
    border: 2px solid black;
    margin-top: 20px;
  }

  .MaterialStock-grand-total-amount {
    background: none !important;
    box-shadow: none !important;
    border: 1px solid black;
  }

  .MaterialStock-section-header {
    background: none !important;
    border: 2px solid black;
  }

  .MaterialStock-transfer-count {
    background: black !important;
    color: white !important;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaterialStock-container {
    padding: 1rem;
  }

  .MaterialStock-header {
    padding: 1.5rem 1rem;
  }

  .MaterialStock-header h1 {
    font-size: 1.5rem;
  }

  .MaterialStock-controls-section {
    flex-direction: column;
    align-items: stretch;
  }

  .MaterialStock-search-container {
    max-width: none;
  }

  .MaterialStock-control-buttons {
    justify-content: center;
  }

  .MaterialStock-form-grid {
    grid-template-columns: 1fr;
  }

  .MaterialStock-material-inputs {
    grid-template-columns: 1fr;
  }

  .MaterialStock-material-item {
    flex-direction: column;
  }

  .MaterialStock-form-actions {
    flex-direction: column;
  }

  .MaterialStock-section-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .MaterialStock-transfers-table {
    font-size: 0.75rem;
  }

  .MaterialStock-transfers-table th,
  .MaterialStock-transfers-table td {
    padding: 0.5rem;
  }

  .MaterialStock-action-buttons {
    flex-direction: column;
  }

  .MaterialStock-grand-total {
    flex-direction: column;
    align-items: flex-end;
    gap: 0.5rem;
  }
}

@media (max-width: 480px) {
  .MaterialStock-modal-overlay {
    padding: 0.5rem;
  }

  .MaterialStock-modal-header,
  .MaterialStock-transfer-form {
    padding: 1rem;
  }

  .MaterialStock-header h1 {
    font-size: 1.25rem;
  }

  .MaterialStock-header-title {
    flex-direction: column;
    gap: 0.5rem;
  }

  .MaterialStock-btn {
    font-size: 0.75rem;
  }

  .MaterialStock-btn-xs {
    padding: 0.25rem 0.5rem;
    font-size: 0.625rem;
  }
}

.MaterialStock-no-print {
  /* display: ; */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Material/MaterialStock.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,mEAAmE;EACnE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,qCAAqC;EACrC,sCAAsC;EACtC,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qCAAqC;EACrC,sCAAsC;EACtC,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;;wBAEsB;EACtB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;;EAEzB,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB,EAAE,0BAA0B;EAChD,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE,yCAAyC;EAC7D,mBAAmB;EACnB,mEAAmE;EACnE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-primary: #6a11cb;\n  --color-secondary: #f857a6;\n  --color-success: #00b09b;\n  --color-danger: #ff5858;\n  --color-warning: #ffd166;\n  --color-info: #4facfe;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: var(--font-primary);\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n}\n\n/* Main Container */\n.MaterialStock-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  /* padding: 1.5rem; */\n  min-height: 100vh;\n}\n\n/* Header Section */\n\n.MaterialStock-header {\n  /* background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%); */\n  background: linear-gradient(135deg, #4c6a37 100%, #cae4db 0%);\n  padding: 11px 20px;\n  color: white;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  margin-bottom: 40px;\n}\n\n.MaterialStock-header::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.15) 0%,\n    transparent 60%\n  );\n  animation: pulse 15s infinite linear;\n}\n\n@keyframes pulse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.MaterialStock-header-content {\n  position: relative;\n  z-index: 2;\n}\n\n.MaterialStock-title {\n  font-size: 28px;\n  font-weight: 800;\n  margin-bottom: 12px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.MaterialStock-subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.9;\n  text-align: center;\n}\n\n.MaterialStock-header-icon {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.MaterialStock-header h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.MaterialStock-header-subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  opacity: 0.9;\n  font-weight: 400;\n}\n\n/* Controls Section */\n.MaterialStock-controls-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.MaterialStock-search-container {\n  position: relative;\n  flex: 1;\n  max-width: 350px;\n}\n\n.MaterialStock-search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1rem;\n  height: 1rem;\n  color: var(--color-text-tertiary);\n}\n\n.MaterialStock-search-input {\n  width: 100%;\n  padding: 0.625rem 0.75rem 0.625rem 2.5rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  background: var(--color-bg-primary);\n  transition: var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.MaterialStock-search-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.MaterialStock-control-buttons {\n  display: flex;\n  gap: 0.75rem;\n}\n\n/* Buttons */\n.MaterialStock-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  text-decoration: none;\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n\n.MaterialStock-btn-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.MaterialStock-btn-xs {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n}\n\n.MaterialStock-btn-sm {\n  /* padding: 0.5rem 1rem; */\n  padding: 4px 16px;\n  font-size: 0.875rem;\n}\n\n.MaterialStock-btn-primary {\n  /* background: var(--primary-gradient); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #4c6a37;\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialStock-btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialStock-btn-secondary {\n  /* background: var(--secondary-gradient); */\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #4c6a37;\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialStock-btn-secondary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialStock-btn-outline {\n  background: transparent;\n  color: var(--color-text-secondary);\n  border: 1px solid var(--color-border);\n}\n\n.MaterialStock-btn-outline:hover {\n  background: var(--color-bg-tertiary);\n  border-color: var(--color-text-secondary);\n}\n\n.MaterialStock-btn-danger {\n  background: linear-gradient(135deg, #ff5858 0%, #ff4757 100%);\n  color: white;\n}\n\n.MaterialStock-btn-danger:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.MaterialStock-btn-icon {\n  padding: 0.375rem;\n  width: auto;\n  height: auto;\n}\n\n.MaterialStock-btn-edit {\n  background: var(--success-gradient);\n  color: white;\n}\n\n.MaterialStock-btn-delete {\n  background: var(--secondary-gradient);\n  color: white;\n}\n\n/* Modal */\n.MaterialStock-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.MaterialStock-modal-container {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.MaterialStock-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.5rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.MaterialStock-modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-modal-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.375rem;\n  border-radius: var(--border-radius-sm);\n  color: var(--color-text-secondary);\n  transition: var(--transition-fast);\n}\n\n.MaterialStock-modal-close-btn:hover {\n  background: var(--color-bg-tertiary);\n  color: var(--color-text-primary);\n}\n\n/* Form */\n.MaterialStock-transfer-form {\n  padding: 1.5rem;\n}\n\n.MaterialStock-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.MaterialStock-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.MaterialStock-form-group label {\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.MaterialStock-form-input,\n.MaterialStock-form-select {\n  padding: 0.625rem 0.75rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  background: var(--color-bg-primary);\n  transition: var(--transition-fast);\n}\n\n.MaterialStock-form-input:focus,\n.MaterialStock-form-select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n/* Materials Section */\n.MaterialStock-materials-section {\n  margin-bottom: 1.5rem;\n}\n\n.MaterialStock-materials-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  margin-top: 10px;\n}\n\n.MaterialStock-materials-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-materials-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.MaterialStock-material-item {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  padding: 1rem;\n  background: var(--color-bg-tertiary);\n  border-radius: var(--border-radius-sm);\n  border: 1px solid var(--color-border);\n}\n\n.MaterialStock-material-inputs {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 5px;\n  flex: 1;\n}\n\n.MaterialStock-form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--color-border);\n}\n\n/* Transfers Section */\n.MaterialStock-transfers-section {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.MaterialStock-section-header {\n  /* display: flex;\n  justify-content: space-between;\n  align-items: center; */\n  padding: 1.5rem;\n  text-align: center;\n  /* background: var(--card-gradient); */\n  /* border-bottom: 1px solid var(--color-border); */\n}\n\n.MaterialStock-section-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-transfer-count {\n  background: var(--primary-gradient);\n  color: white;\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Table */\n.MaterialStock-table-container {\n  overflow-x: auto;\n}\n\n.MaterialStock-transfers-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  background: var(--color-bg-primary);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  box-shadow: var(--shadow-md);\n  overflow-x: auto;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.MaterialStock-transfers-table th {\n  background: var(--color-bg-tertiary);\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid var(--color-border);\n}\n\n.MaterialStock-transfers-table td {\n  padding: 1rem;\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: top;\n  font-size: 0.875rem;\n}\n\n.MaterialStock-transfers-table tr:hover {\n  background: var(--color-bg-secondary);\n}\n\n.MaterialStock-date-text {\n  font-weight: 600;\n  /* color: var(--color-primary); */\n  color: #0d5787;\n}\n\n.MaterialStock-site-cell {\n  display: flex;\n  align-items: center;\n  /* flex-direction: column; */\n  font-size: 15px;\n}\n\n.MaterialStock-site-name {\n  font-weight: 600;\n  /* color: var(--color-text-primary); */\n  /* color: #fff; */\n}\n\n.Material-SiteName-Badge {\n  display: inline-flex; /* shrink to fit content */\n  align-items: center;\n  justify-content: center;\n  width: fit-content; /* ensures background fits content only */\n  background: #4c6a37;\n  /* background: linear-gradient(135deg, #20948b 0%, #66a5ad 100%); */\n  color: #fff;\n  border-radius: 1rem;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap; /* prevents wrapping if site name is long */\n}\n\n.MaterialStock-LocationIcon {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n}\n.MaterialStock-note-text {\n  color: var(--color-text-secondary);\n  font-style: italic;\n}\n\n.MaterialStock-material-name {\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-qty,\n.MaterialStock-cost,\n.MaterialStock-total {\n  font-weight: 500;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-total {\n  font-weight: 700;\n  color: var(--color-success);\n}\n\n.MaterialStock-action-buttons {\n  display: flex;\n  gap: 0.375rem;\n}\n\n/* Grand Total Section */\n.MaterialStock-grand-total-section {\n  padding: 1.5rem;\n  background: var(--card-gradient);\n  border-top: 1px solid var(--color-border);\n}\n\n.MaterialStock-grand-total {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n}\n\n.MaterialStock-grand-total-label {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-grand-total-amount {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--color-success);\n  background: var(--color-bg-primary);\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius-sm);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Empty State */\n.MaterialStock-empty-state {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.MaterialStock-empty-icon {\n  width: 3rem;\n  height: 3rem;\n  color: var(--color-text-tertiary);\n  margin-bottom: 1rem;\n}\n\n.MaterialStock-empty-state h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.MaterialStock-empty-state p {\n  margin: 0;\n  color: var(--color-text-secondary);\n}\n\n/* Print Styles */\n@media print {\n  .MaterialStock-no-print {\n    display: none !important;\n  }\n\n  .MaterialStock-container {\n    padding: 0;\n    max-width: none;\n  }\n\n  .MaterialStock-header {\n    background: none !important;\n    color: black !important;\n    box-shadow: none !important;\n    border: 2px solid black;\n  }\n\n  .MaterialStock-controls-section {\n    display: none !important;\n  }\n\n  .MaterialStock-transfers-table {\n    font-size: 12px;\n    border: 1px solid black;\n  }\n\n  .MaterialStock-transfers-table th,\n  .MaterialStock-transfers-table td {\n    padding: 8px;\n    border: 1px solid black;\n  }\n\n  .MaterialStock-transfers-table th {\n    background: #f0f0f0 !important;\n  }\n\n  .MaterialStock-grand-total-section {\n    background: none !important;\n    border: 2px solid black;\n    margin-top: 20px;\n  }\n\n  .MaterialStock-grand-total-amount {\n    background: none !important;\n    box-shadow: none !important;\n    border: 1px solid black;\n  }\n\n  .MaterialStock-section-header {\n    background: none !important;\n    border: 2px solid black;\n  }\n\n  .MaterialStock-transfer-count {\n    background: black !important;\n    color: white !important;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaterialStock-container {\n    padding: 1rem;\n  }\n\n  .MaterialStock-header {\n    padding: 1.5rem 1rem;\n  }\n\n  .MaterialStock-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .MaterialStock-controls-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaterialStock-search-container {\n    max-width: none;\n  }\n\n  .MaterialStock-control-buttons {\n    justify-content: center;\n  }\n\n  .MaterialStock-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .MaterialStock-material-inputs {\n    grid-template-columns: 1fr;\n  }\n\n  .MaterialStock-material-item {\n    flex-direction: column;\n  }\n\n  .MaterialStock-form-actions {\n    flex-direction: column;\n  }\n\n  .MaterialStock-section-header {\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n  }\n\n  .MaterialStock-transfers-table {\n    font-size: 0.75rem;\n  }\n\n  .MaterialStock-transfers-table th,\n  .MaterialStock-transfers-table td {\n    padding: 0.5rem;\n  }\n\n  .MaterialStock-action-buttons {\n    flex-direction: column;\n  }\n\n  .MaterialStock-grand-total {\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialStock-modal-overlay {\n    padding: 0.5rem;\n  }\n\n  .MaterialStock-modal-header,\n  .MaterialStock-transfer-form {\n    padding: 1rem;\n  }\n\n  .MaterialStock-header h1 {\n    font-size: 1.25rem;\n  }\n\n  .MaterialStock-header-title {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .MaterialStock-btn {\n    font-size: 0.75rem;\n  }\n\n  .MaterialStock-btn-xs {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.625rem;\n  }\n}\n\n.MaterialStock-no-print {\n  /* display: ; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
